import React, { useContext, useEffect, useState } from 'react';
import { useSearchParams, useLocation, useNavigate } from 'react-router-dom';
import { getRegion } from '../utils/Region';
import { PLAYER_SEGMENT } from '../constants';
import getFirstNode from 'utils/getFirstNode';
import { useSelector } from 'react-redux';
import { getClaroAdsKey } from 'utils/claroAds/getClaroAdskey';
import CombinedContext from 'context/CombinedContext';

const DeepLinkHandler = ({ children }) => {
  const { isAppReady, isLinealChannelReady } = useContext(CombinedContext);
  const [deepLinkConfig, setDeepLinkConfig] = useState({
    isLoading: true,
    type: '',
    callback: undefined,
  });
  const [serachParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const isRedirectFromServer = location.hash.includes('popGId');
  const claroLiteConfig = useSelector(state => getClaroAdsKey(state));
  const firstNode = getFirstNode(claroLiteConfig);
  const user = useSelector(state => state.user) || {};
  const isForgettenPassword = window.location.pathname?.includes(
    'forgottenPassword',
  );

  const onPlayerDeepLink = () => {
    const groupId = serachParams.get('group_id');
    const isPreview = serachParams.get('preview');
    const showPlayer = serachParams.get('showPlayer');

    if (!user?.userhash)
      return navigate(
        `/${getRegion()}/vcard/homeuser/-/${location.hash?.split('=')?.[1]}`,
        { replace: true },
      );
    if (showPlayer && groupId && isPreview) {
      return navigate(
        `/${getRegion()}${PLAYER_SEGMENT}${groupId}?preview=true`,
        { replace: true },
      );
    }

    if (showPlayer && groupId) {
      return navigate(`/${getRegion()}${PLAYER_SEGMENT}${groupId}`, {
        replace: true,
      });
    }

    if (isRedirectFromServer) return;

    return navigate(`/${getRegion()}/${firstNode}`);
  };
  const onMyAccountDeepLink = () => {
    const newSearchParams = location.search.replace(/\.php/g, '');
    return navigate(`${location?.pathname}${newSearchParams}`);
  };

  const isDeepLink = () => {
    if (location.hash.includes('popGId'))
      return {
        type: 'player',
        callback: onPlayerDeepLink,
      };
    if (location.search.includes('user.php')) {
      return {
        type: 'myAccount',
        callback: onMyAccountDeepLink,
      };
    }
    //TODO: por params
    return {
      type: 'none',
      callback: () => {},
    };
  };

  useEffect(() => {
    setDeepLinkConfig({ isLoading: false, ...isDeepLink() });
  }, []);

  useEffect(
    () => {
      const { callback, isLoading, type } = deepLinkConfig;
      if (!type || !callback || isLoading) return;
      callback();
    },
    [deepLinkConfig],
  );

  if (isForgettenPassword) return children;

  if (
    !deepLinkConfig.type ||
    !deepLinkConfig.callback ||
    deepLinkConfig.isLoading ||
    !isAppReady ||
    !isLinealChannelReady
  )
    return <></>;

  return children;
};

export default DeepLinkHandler;
